import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Measure = createSvgIcon(
  <path d="M6.75 0H0v2.25h2.25V13.5H0v2.25h6.75V13.5H4.5V2.25h2.25V0ZM24 0H8.25v15.75H24V0ZM10.5 13.5V2.25h11.25V13.5H10.5Zm0 6h11.25v-2.25H24V24h-2.25v-2.25H10.5V24H8.25v-6.75h2.25v2.25Zm-7.125 3a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />,
  'Measure'
);

export { Measure };